import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { Input } from "antd";
import { useCallback, useEffect, useState } from "react";
import { getCuentaBancariaContifico } from "../../../Service/Service.ContificoAPI";
import { useSelector } from "react-redux";

function ModalTransferencia({ data }) {

    const { show, handleClose, handleAgregarDatoBancarios } = data;
    const pagos = useSelector((state) => state.formapagoredux.pagos ) || [];

    const [datoTransferencia, setDatoTransferencia] = useState({ num_comprobante: "", cuenta_bancaria_id: "", tipo: "TRA" });
    const [loading, setLoading] = useState(false);
    const [listaBancos, setListaBancos] = useState([]);
    const [isEditing, setIsEditing] = useState(false);

    const handleChange = (event) => {
        const value = event.target.value.replace(/[^0-9.]/g, "");
        setDatoTransferencia({ ...datoTransferencia, [event.target.name]: value });
    };

    const guardarDatosBancarios = async () => {
        setLoading(true);
        handleAgregarDatoBancarios(datoTransferencia);
        setDatoTransferencia({ num_comprobante: "", cuenta_bancaria_id: "" });
        setLoading(false);
    }

    const fetchInitialData = useCallback(async () => {
        const cuentaBancaria = await getCuentaBancariaContifico();
        if (cuentaBancaria && cuentaBancaria.success) {
            setListaBancos(cuentaBancaria.data);
        }

    }, []);

    const handleSeleccionarBanco = (id) => {
        setDatoTransferencia({ ...datoTransferencia, cuenta_bancaria_id: id });
    };

    useEffect(() => {
        if (show && pagos.length > 0) {
            
            const pagoTRA = pagos.find(pago => pago.datosBancario.tipo === "TRA");

            if (pagoTRA) {
                setIsEditing(true);
                setDatoTransferencia({
                    cuenta_bancaria_id: pagoTRA.datosBancario.cuenta_bancaria_id || "",
                    num_comprobante: pagoTRA.datosBancario.num_comprobante || "",
                    tipo: "TRA",
                });
            }
        }
    }, [show, pagos]);    

    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="md">
            <Modal.Header closeButton>
                <Modal.Title>{ isEditing ? 'Actualizar' : 'Agregar'} Datos Transferencia</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <div className="form-group col-md-12">
                                <label htmlFor="no_cheque">
                                    Seleccione Banco:
                                </label>


                                <div className="d-flex flex-wrap justify-content-start pb-2">
                                    {listaBancos.length > 0 ? (
                                        listaBancos.map((banco) => (
                                            <button
                                                key={banco.id}
                                                className={`btn m-1 ${datoTransferencia.cuenta_bancaria_id === banco.id
                                                    ? "btn-primary"
                                                    : "btn-outline-primary"
                                                    }`}
                                                onClick={() => handleSeleccionarBanco(banco.id)}
                                            >
                                                {banco.nombre}
                                            </button>
                                        ))
                                    ) : (
                                        <p className="text-muted">Cargando tipos de transacción...</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <div className="form-group col-md-12">
                                <label htmlFor="num_comprobante">
                                    No. de Comprobante
                                </label>
                                <Input
                                    type="text"
                                    className="me-2 flex-grow-1"
                                    id="num_comprobante"
                                    value={datoTransferencia.num_comprobante}
                                    name="num_comprobante"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </Col>

                </Row>

            </Modal.Body>

            <Modal.Footer>
                <div className="mb-3 text-end">
                    <button className="btn btn-light m-1" disabled={loading} onClick={handleClose}>Cancelar</button>
                    <button className="btn btn-primary m-1" onClick={guardarDatosBancarios} disabled={loading || !datoTransferencia.num_comprobante || !datoTransferencia.cuenta_bancaria_id}>
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Por favor espere...
                            </>
                        ) : isEditing ? 'Actualizar' : 'Agregar' }
                    </button>
                </div>
            </Modal.Footer>

        </Modal>
    )

}

export default ModalTransferencia;
